<div mat-dialog-title>
    {{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.ACTIONS.CREATE_RECORD.FORMATION_TITLE' | translate | uppercase}}
</div>
<div mat-dialog-content>
    <mat-card-content>
        <form [formGroup]="formGroup">
            <mat-form-field class="w100">
                <input #searchInput type="text" matInput formControlName="search" [matAutocomplete]="auto"
                    [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate">
                <div matSuffix class="app-suffix-search-icon-wrapper">
                    <button mat-icon-button (click)="searchFormacion()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                    (optionSelected)="selectFormacion($event.option.value)">
                    <mat-option *ngFor="let formacion of options" [value]="formacion">
                        {{formacion.idcurso ? formacion.idcurso + ' ' : ''}}{{formacion.campus ? formacion.campus + ': ' : ''}}{{formacion['año_imparticion']}} / {{formacion.num_edicion}} /
                        {{formacion.nombre_curso}}</mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="formGroup.get('search').hasError('minlength')">
                    {{ 'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.STEPS.AUTHORS.MIN_LENGTH' | translate }}
                </mat-error>
            </mat-form-field>
        </form>

        <mat-card *ngIf="formacion">
            <mat-card-content>
                <div class="div-wrap">
                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.COURSE_ID' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion.idcurso"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.CAMPUS' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion.campus"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.YEAR_IMPARTATION' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion['año_imparticion']"
                            [disabled]="true"></textarea>
                    </mat-form-field>
                    
                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.EDITION_NUM' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion.num_edicion"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.COURSE_NAME' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion.nombre_curso"
                            [disabled]="true"></textarea>
                    </mat-form-field>

                    <mat-form-field class="w45">
                        <mat-label>{{'DEUSTO.NEW_MENU.MENU_ITEMS.RECORDS.CONTINUOUS_FORMATION.COURSE_CENTER' | translate}}</mat-label>
                        <textarea matInput cdkTextareaAutosize [(ngModel)]="formacion.centro"
                            [disabled]="true"></textarea>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>

        <div class="spinner-center" *ngIf="loading">
            <mat-spinner></mat-spinner>
        </div>
    </mat-card-content>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="accent">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.NO_LABEL' | translate }}
    </button>
    <button mat-raised-button [mat-dialog-close]="formacion" [disabled]="formacion === null || formacion === undefined"
        color="primary">
        {{ 'ALDEN.DIALOGS.CHOOSE_OPTION.YES_LABEL' | translate }}
    </button>
</div>